$(document).ready(function () {
    // If .navbar-toggler is hidden, then we are in mobile state
    // Driven by css
    if ($("#nav-menu .navbar-toggler").is(':hidden')) {
        $("#nav-menu, #navigation-footer").find('.dropdown-toggle.nav-link').removeAttr('data-toggle');
    }

});